export type InfraStatus = 'normal' | 'critical' | 'noData';

export function getInfraStatus(infra: any): InfraStatus {
	const mt = infra?.mainMeasurementTarget;

	if (mt?.expired === true) {
		return 'noData';
	}

	if (typeof mt?.usage === 'number' && mt.usage > 100) {
		return 'critical';
	}

	return 'normal';
}

export function getInfraId(infra: any): number | undefined {
	return infra?.measurementeInfraestructureId ?? infra?.infraestructureId;
}
